/**
 * Developer notes:
 *
 * <ReactBaseProvider
 *      enableTranslationLayer // enables the translation layer of ReactBase
 *      defaultTranslationInformationStringBehaviour="translate | noTranslate" // defines the default behavior of just strings like <Text>some text</Text>
 *      missingTranslationPrefix="⚠️" // later we support that
 * />
 */
export function isPlainTranslationInformation(translationInformation) {
    return translationInformation.plain !== undefined;
}
//# sourceMappingURL=TranslationInformation.js.map